<template>
    <div class="p-exclusive-users">
        <div class="card">
            <div class="card-header">専属{{ $locale.patient }}管理</div>

            <div class="card-body p-exclusive-users__content pt-2"
                 :class="{ 'u-loader u-loader--p5' : ! users }">

                <div v-if="users">
                    <div class="d-block d-md-flex justify-content-between mb-3">
                        <div class="d-block d-md-flex flex-wrap align-items-center">
                            <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                <div class="input-group input-group-sm">
                                    <select
                                        v-model="sex"
                                        @change="fetchExclusiveUsers"
                                        id="sex"
                                        style="min-width: 100px;"
                                        class="form-control">
                                        <option :value="null">性別を選択してください</option>
                                        <option value="male">男性</option>
                                        <option value="female">女性</option>
                                        <option value="all">すべての性別</option>
                                    </select>
                                </div>
                            </div>

                            <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                <div class="input-group input-group-sm">
                                    <select v-model="prefecture"
                                            @change="fetchExclusiveUsers"
                                            id="prefmap"
                                            style="min-width: 100px;"
                                            class="form-control">
                                        <option :value="null">都道府県を選択してください</option>
                                        <option v-for="pref in prefmap" :value="pref">
                                            {{ pref }}
                                        </option>
                                        <option value="all">すべての地域</option>
                                    </select>
                                </div>
                            </div>

                            <div class="mt-2 mr-0 mb-2 mr-md-2 mb-md-0">
                                <div class="input-group input-group-sm">
                                    <select
                                        v-model="user_category_id"
                                        @change="fetchExclusiveUsers"
                                        id="user_category_id"
                                        style="min-width: 100px;"
                                        class="form-control">
                                        <option :value="null">{{ $locale.patient }}区分を選択してください</option>
                                        <option v-for="user_category in user_categories" :value="user_category.id">
                                            {{ user_category.name }}
                                        </option>
                                        <option value="all">すべての{{ $locale.patient }}区分</option>
                                    </select>
                                </div>
                            </div>

                            <div class="mt-2">
                                <div class="c-freeword input-group input-group-sm">
                                    <input
                                        v-model="freeword"
                                        type="text"
                                        class="form-control"
                                        name="freeword"
                                        id="freeword"
                                        placeholder="フリーワード">
                                    <div class="input-group-append">
                                        <div
                                            class="c-freeword__btn input-group-text"
                                            @click="fetchExclusiveUsers">検索
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="mt-2 pt-2 pt-md-1 ml-2 text-right">
                            <div
                                class="btn btn-sm btn-yokumiru-orange"
                                style="min-width: 110px;"
                                @click="showModalAddExclusiveUser">
                                専属{{ $locale.patient }}追加
                            </div>
                        </div>
                    </div>

                    <b-table striped hover
                             :items="users"
                             :fields="fields"
                             :sort-by.sync="sortBy"
                             :sort-desc.sync="sortDesc"
                             :sort-compare="sortCompare"
                             @sort-changed="fetchExclusiveUsers"
                             :responsive="true">

                        <template v-slot:cell(user_category_id)="data">
                            <div v-for="user_category in user_categories">
                                <div v-if="user_category.id === data.item.user_category_id">
                                    {{ user_category.name }}
                                </div>
                            </div>
                        </template>

                        <template v-slot:cell(user.full_name_kana)="data">
                            <a href="#" @click="showModalUserProfile( data.item.id )">
                                {{ data.item.full_name }}
                            </a>
                            <div class="small">{{ data.item.full_name_kana }}</div>
                        </template>

                        <template v-slot:cell(sex)="data">
                            <span>{{ Number( data.item.sex ) > 0 ? '女性' : '男性' }}</span>
                        </template>

                        <template v-slot:cell(prefecture)="data">
                            <span v-if="data.item.country !== '日本'">{{ data.item.country + ' , ' }}</span>
                            <span v-if="data.item.prefecture === null">-</span>
                            <span v-else>{{ data.item.prefecture }}</span>
                        </template>

                        <template v-slot:cell(height)="data">
                            <span v-if="data.item.height">{{ data.item.height }}cm</span>
                            <span v-else>-</span>
                        </template>

                        <template v-slot:cell(weight)="data">
                            <span v-if="data.item.weight">{{ data.item.weight }}kg</span>
                            <span v-else>-</span>
                        </template>

                        <template v-slot:cell(links)="data">
                            <div class="d-flex justify-content-end">
                                <div>
                                    <b-button v-if="data.item.stopped_at == null" type="button"
                                              class="btn btn-success btn-sm m-1" data-toggle="modal"
                                              data-target="#doctorStop" @click="showModalStopExclusiveUser(data.item)">利用中
                                    </b-button>
                                </div>

                                <div>
                                    <b-button v-if="data.item.stopped_at != null" type="button"
                                              class="btn btn-metal btn-sm m-1" data-toggle="modal"
                                              data-target="#doctorStop" @click="showModalComebackExclusiveUser(data.item)">停止中
                                    </b-button>
                                </div>

                                <div>
                                    <b-button type="button"
                                              class="btn btn-yokumiru-blue btn-sm m-1" data-toggle="modal"
                                              data-target="#doctorStop" @click="showModalEditExclusiveUser(data.item)">編集
                                    </b-button>
                                </div>

                                <div>
                                    <b-button type="button" class="btn btn-danger btn-sm m-1" data-toggle="modal"
                                              data-target="#doctorDelete" @click="showModalDeleteExclusiveUser(data.item)">削除
                                    </b-button>
                                </div>
                            </div>
                        </template>
                    </b-table>

                    <div class="mt-3 d-flex flex-wrap justify-content-between align-items-center">
                        <b-pagination
                            :total-rows="paginationConf.totalRows"
                            :per-page="paginationConf.perPage"
                            v-model="paginationConf.currentPage"
                            @change="fetchExclusiveUsers">
                        </b-pagination>

                        <div class="mb-3 mr-3">
                            <span class="small ml-2">{{ dispPaginationDetail }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <user-profile-modal :doctor-id="doctorId"/>
        <exclusive-user-add-modal/>
        <exclusive-user-stop-modal/>
        <exclusive-user-comeback-modal/>
        <exclusive-user-delete-modal/>
        <exclusive-user-edit-modal/>
    </div>
</template>

<script>
    import constants from "../../constants"

    export default  {
        props: {
            doctorId: {
                type: Number,
                required: true,
            },
        },

        data: function() {
            return {
                modalShow: false,
                users: null,
                freeword: '',
                sex: null,
                prefecture: null,
                user_categories: [],
                user_category_id: null,
                paginationConf: {
                    currentPage: 1,
                    perPage: 10,
                    totalRows: 0,
                    from: 0,
                    to: 0,
                },
                sortBy: 'id',
                sortDesc: false,
                prefmap: [
                    '北海道',   '青森県',   '岩手県',   '宮城県',
                    '秋田県',   '山形県',   '福島県',   '茨城県',   '栃木県',
                    '群馬県',   '埼玉県',   '千葉県',   '東京都',   '神奈川県',
                    '新潟県',   '富山県',   '石川県',   '福井県',   '山梨県',
                    '長野県',   '岐阜県',   '静岡県',   '愛知県',   '三重県',
                    '滋賀県',   '京都府',   '大阪府',   '兵庫県',   '奈良県',
                    '和歌山県', '鳥取県',   '島根県',   '岡山県',   '広島県',
                    '山口県',   '徳島県',   '香川県',   '愛媛県',   '高知県',
                    '福岡県',   '佐賀県',   '長崎県',   '熊本県',   '大分県',
                    '宮崎県',   '鹿児島県', '沖縄県',
                ],
                fields: [
                    {
                        key: 'id',
                        'label': `${this.$locale.patient}番号`,
                        sortable: true,
                    },
                    {
                        'key': 'user_category_id',
                        'label': `${this.$locale.patient}区分`,
                        sortable: true,
                    },
                    {
                        'key': 'user_code',
                        'label': '所属コード',
                        sortable: true,
                    },
                    {
                        key: 'user.full_name_kana',
                        label: `${this.$locale.patient}名`,
                        sortable: true,
                    },
                    {
                        key: 'sex',
                        label: '性別',
                        sortable: true,
                    },
                    {
                        key: 'age',
                        label: '年齢',
                        sortable: true,
                    },
                    {
                        key: 'height',
                        label: '身長',
                        sortable: true,
                    },
                    {
                        key: 'weight',
                        label: '体重',
                        sortable: true,
                    },
                    {
                        key: 'postcode',
                        label: '郵便番号',
                        sortable: true,
                    },
                    {
                        key: 'prefecture',
                        label: '都道府県',
                        sortable: true,
                    },
                    {
                        key: 'address',
                        label: '市区町村・番地',
                        sortable: true,
                    },
                    {
                        key: 'building',
                        label: '建物名など',
                        sortable: true,
                    },
                    {
                        key: 'tel',
                        label: '電話番号',
                        sortable: true,
                    },
                    {
                         key: 'links',
                         label: '',
                        sortable: false,
                    },
                ],
            };
        },

        created: function() {
            this.initQuery();
            this.fetchExclusiveUsers();
            this.user_category();
            bus.$on( 'refresh-exclusive-users', this.fetchExclusiveUsers );
        },

        beforeDestroy: function() {
            bus.$off( 'refresh-exclusive-users' );
        },

        methods: {
            /**
             * QueryString初期化
             * バリデーションはLaravel側を参照
             *
             */
            initQuery: function () {
                this.sex = this.$route.query.sex || null;
                this.prefecture = this.$route.query.prefecture || null;
                this.user_category_id = Number( this.$route.query.user_category_id ) || null;
                this.freeword = this.$route.query.freeword || '';
                this.sortBy = this.$route.query.sort || 'id';
                this.sortDesc = this.$route.query.desc !== 'false';
                this.paginationConf.currentPage = Number(this.$route.query.page) || 1;
            },

            /**
             * QueryString更新
             *
             * @param {object} ctx
             */
            updateQuery: function ( ctx ) {
                if ( ctx !== null && ctx.hasOwnProperty( 'sortBy' ) ) {
                    this.sortBy = ctx.sortBy;
                    this.sortDesc = ctx.sortDesc;
                }

                this.$router.replace( {
                    path: this.$route.path,
                    query: {
                        sex: this.sex,
                        prefecture: this.prefecture,
                        freeword: this.freeword,
                        user_category_id: Number.isInteger(this.user_category_id) ? this.user_category_id : null,
                        sort: this.sortBy,
                        desc: this.sortDesc,
                        page: this.paginationConf.currentPage,
                    },
                } ).catch(error => {});
            },

            /**
             * 専属患者取得
             *
             * @param {number} param
             */
            fetchExclusiveUsers: function( param = null  ) {
                this.users = null;
                this.paginationConf.currentPage = ( typeof param === 'number' ) ? param : 1;

                this.updateQuery( param );
                let endpoint = `/doctor/api/${this.doctorId}/users/exclusive`;
                axios.get( `${endpoint}${this.buildQuery}` )
                    .then( ({data}) => {
                        this.users = data.data;
                        this.paginationConf.perPage = data.per_page;
                        this.paginationConf.totalRows = data.total;
                        this.paginationConf.from = data.from;
                        this.paginationConf.to = data.to;
                    } );
            },

            /**
             * [bootstrap-vue]
             * テーブルソート
             *
             * @param a
             * @param b
             * @param key
             *
             * @return {boolean}
             */
            sortCompare: function ( a, b, key ) {
                if ( typeof a[key] === 'number' && typeof b[key] === 'number' ) {
                    return a[key] < b[key] ? -1 : ( a[key] > b[key] ? 1 : 0 )
                }
                else {
                    let valueA = a[key];
                    let valueB = b[key];

                    if ( key === 'user.full_name' ) {
                        valueA = a['full_name_kana'];
                        valueB = b['full_name_kana'];
                    }

                    return this.toString( valueA ).localeCompare( this.toString( valueB ), undefined, {
                        numeric: true
                    } );
                }
            },

            /**
             * 文字列比較（テーブルソート用）
             *
             * @param v
             * @return {string}
             */
            toString: function (v) {
                if (!v) {
                    return ''
                }
                if (v instanceof Object) {
                    return keys(v)
                        .map(k => toString(v[k]))
                        .join(' ')
                }
                return String(v)
            },

            /**
             * 会員詳細モーダル表示
             *
             * @return {void}
             */
            showModalUserProfile: function( user_id ) {
                bus.$emit( 'open-modal-user-profile', user_id );
            },

            /**
             * 専属患者の追加モーダル表示
             *
             * @return {void}
             */
            showModalAddExclusiveUser: function() {
                bus.$emit( 'open-modal-exclusive-user-add', this.doctorId );
            },

            showModalStopExclusiveUser: function (data) {
                bus.$emit( 'open-modal-exclusive-user-stop', data , this.doctorId );
            },
            showModalComebackExclusiveUser: function (data) {
                bus.$emit( 'open-modal-exclusive-user-comeback', data , this.doctorId );
            },
            showModalDeleteExclusiveUser: function (data) {
                bus.$emit( 'open-modal-exclusive-user-delete', data , this.doctorId );
            },
            showModalEditExclusiveUser: function (data) {
                bus.$emit( 'open-modal-exclusive-user-edit', data, this.doctorId );
            },

            user_category: function () {
                axios.get(constants.doctor.users.endpoint.user_categories)
                    .then(({data}) => {
                        this.user_categories = data
                    })
                    .catch(function (error) {
                        console.log(error)
                    })
            },
        },
        computed: {
            /**
             * QueryString生成
             *
             * @return {string}
             */
            buildQuery: function () {
                let query = `?page=${this.paginationConf.currentPage}`;
                query += `&sort=${this.sortBy}`;
                query += `&desc=${this.sortDesc}`;

                if (this.sex && this.sex.length > 0) {
                    query += `&sex=${this.sex}`;
                }
                if ( Number.isInteger( this.user_category_id ) ) {
                    query += `&user_category_id=${this.user_category_id}`;
                }
                if (this.prefecture && this.prefecture.length > 0) {
                    query += `&prefecture=${this.prefecture}`;
                }
                if (this.freeword && this.freeword.length > 0) {
                    query += `&freeword=${this.freeword}`;
                }

                return query;
            },

            /**
             * ページング詳細表示
             * @returns {string}
             */
            dispPaginationDetail: function () {
                if ( this.paginationConf.totalRows < 1 ) {
                    return '';
                }
                if ( this.paginationConf.from == null ) {
                    this.paginationConf.from = 0;
                }
                if ( this.paginationConf.to == null ) {
                    this.paginationConf.to = 0;
                }
                return `全${this.paginationConf.totalRows}件中 ${this.paginationConf.from}～${this.paginationConf.to}件表示`;
            },
        },
    }
</script>
